const createConsult = `
mutation createConsult ($data: ConsultCreateInput!) {
  createConsult (data: $data) {
      ctId,
  }
}
`

export { createConsult }
